import { Toaster } from "@/components/ui/toaster";
import { GlobalNotifications } from "@/components/GlobalNotifications";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import News from "./pages/News";
import Profile from "./pages/Profile";
import Sfondi from "./pages/Sfondi";
import AppleStore from "./pages/AppleStore";
import Abbonamenti from "./pages/Abbonamenti";
import Prodotti from "./pages/Prodotti";
import ConfrontaIPhone from "./pages/ConfrontaIPhone";
import Messaggi from "./pages/Messaggi";
import NotFound from "./pages/NotFound";
import { useTheme } from "./hooks/useTheme";
import { ThemeOnboarding } from "./components/ThemeOnboarding";
import { SplashScreen } from "./components/SplashScreen";
import { useState, useCallback } from "react";

const queryClient = new QueryClient();

const AnimatedRoutes = () => {
  const location = useLocation();
  const { showOnboarding, setTheme } = useTheme();
  const [showSplash, setShowSplash] = useState(true);
  const handleSplashComplete = useCallback(() => setShowSplash(false), []);

  return (
    <>
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
      {showOnboarding && !showSplash && <ThemeOnboarding onSelect={setTheme} />}
      <div style={showSplash ? { visibility: 'hidden', height: 0, overflow: 'hidden' } : undefined} aria-hidden={showSplash || undefined}>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/news" element={<News />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/sfondi" element={<Sfondi />} />
            <Route path="/apple-store" element={<AppleStore />} />
            <Route path="/abbonamenti" element={<Abbonamenti />} />
            <Route path="/prodotti" element={<Prodotti />} />
            <Route path="/confronta-iphone" element={<ConfrontaIPhone />} />
            <Route path="/messaggi" element={<Messaggi />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </div>
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <GlobalNotifications />
        <AnimatedRoutes />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
